{getIdsAsList} = require('../../utils')

module.exports = (
  $scope,
  $rootScope,
  User,
  languages,
  Api
) ->

  $scope.user = User
  $scope.userProfile = User.userprofile
  $scope.languages = languages

  $scope.saving = false

  handleSave = ->
    $scope.saving = false
    $rootScope.message = 'Preferences successfully saved'

  $scope.save = ->
    $scope.saving = true
    preferences = new Api.Preferences
      id: $scope.userProfile.id
      telephone: $scope.userProfile.telephone or ''
      reading_language: $scope.userProfile.reading_language?.id
      languages: getIdsAsList($scope.userProfile.languages, 'id')
      project_order:  $scope.userProfile.project_order or ''
    preferences.$update().then handleSave
